// Component for displaying About and Terms links at the bottom of the application
import { Link } from "react-router-dom";
import { Info, ScrollText } from "lucide-react";

/**
 * MenuBottomBar component that displays About and Terms links at the bottom of the left menu
 * This component is designed to be placed at the very bottom of the left navigation menu
 */
export default function MenuBottomBar() {
  return (
    <div className="w-full flex justify-between px-3 py-3 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
      <Link
        to="/company/about"
        className="flex items-center p-1 rounded-lg hover:bg-[#065900] dark:hover:bg-[#065900] text-gray-700 dark:text-gray-300 hover:text-white dark:hover:text-white"
      >
        <Info className="w-4 h-4 mr-1" />
        <span className="text-xs">About</span>
      </Link>
      <Link
        to="/creators/terms"
        className="flex items-center p-1 rounded-lg hover:bg-[#065900] dark:hover:bg-[#065900] text-gray-700 dark:text-gray-300 hover:text-white dark:hover:text-white"
      >
        <ScrollText className="w-4 h-4 mr-1" />
        <span className="text-xs">Terms</span>
      </Link>
    </div>
  );
}
